import { Turbo } from '@hotwired/turbo-rails'
import '../replayer/controllers'

const importAll = (r) => r.keys().forEach(r)

importAll(require.context('../replayer/components/', true, /^(?!.*\.stories\.js$).+\.js$/))

import 'replayer/stylesheets/website.scss'
